module.exports = __webpack_public_path__ + "img/logo.bf121f27.svg";